export const grid = () => (
  <path
    d="M10 3H3v7h7V3zM21 3h-7v7h7V3zM21 14h-7v7h7v-7zM10 14H3v7h7v-7z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
